import React from "react";
import Home1 from "../Assets/home3.png";
import About1 from "../Assets/about.png";
import Solutions1 from "../Assets/Artboard 3.jpg"
import Services1 from "../Assets/Artboard 2.jpg"
import Logo1 from "../Assets/logo1.png";
import Logo2 from "../Assets/logo2.png";
import Logo3 from "../Assets/logo3.png";
import Logo4 from "../Assets/logo4.png";
import bajajLogo from "../Assets/Asset 4.png";
import Hero from "../Assets/Asset 2.png";
import Mahindra from "../Assets/Asset 1.png";
import Atul from "../Assets/Atul.png";
import Wockhardt from "../Assets/wockhardtpng.png";
import Haier from "../Assets/Haier.png";
import Legrand from "../Assets/Asset 3.png";
import Schneider from "../Assets/Schneider.png";
import Perkins from "../Assets/Asset 5.png";
import JSW from "../Assets/JSW-removebg-preview.png";
import Lumax from "../Assets/Lumax.png";
import NRB from "../Assets/NRB-logo.png";


function Home() {
  const capabilities = [
  {
    title: "Industrial Automation & Control Systems",
    image: Logo1,
    points: [
      "PLC, HMI, SCADA system design & integration",
      "Motion control, servo systems, VFDs",
      "Robotics including SCARA, 6-axis and collaborative robots",
      "Machine automation and process control",
    ],
  },
  {
    title: "Energy Efficiency & Sustainability",
    image: Logo2,
    points: [
      "Energy-efficient motors, drives and fans",
      "Emission control solutions for DG sets",
      "Daylighting and ventilation systems",
      "Smart energy monitoring and optimization",
    ],
  },
  {
    title: "System Integration & Engineering",
    image: Logo3,
    points: [
      "End-to-end project engineering",
      "Electrical and control panel design",
      "Field instrumentation and industrial devices",
      "OEM-certified system configuration",
    ],
  },
  {
    title: "Technology Partnerships & Products",
    image: Logo4,
    points: [
      "Solutions aligned with Mitsubishi FA, EAPL, Platino Automotive",
      "Skyshade, Paras Green and Binay Opto Electronics",
      "Access to premium automation and sustainability technologies",
    ],
  },
];

  const solutions = [
    "Automation & Digital Factory Solutions",
    "Energy Monitoring & Power Quality",
    "Daylighting & Ventilation Solutions",
    "Energy-Efficient Motors, Fans & Drives",
    "Advanced Industrial & Commercial Lighting",
    "Emission Control & Environmental Solutions",
  ];

const clients = [
  { name: "Bajaj", logo: bajajLogo },
  { name: "Hero", logo: Hero },
  { name: "Mahindra", logo: Mahindra },
  { name: "Atul", logo: Atul },
  { name: "Wockhardt", logo: Wockhardt },
  { name: "Haier", logo: Haier },
  { name: "Legrand", logo: Legrand },
  { name: "Schneider Electric", logo: Schneider },
  { name: "Perkins", logo: Perkins },
  { name: "JSW", logo: JSW },
  { name: "Lumax", logo: Lumax },
  { name: "NRB", logo: NRB },
];

  return (
    <div style={{ overflowX: "hidden", backgroundColor: "#f7fbff" }}>
<section
  style={{
    minHeight: "92vh",
    background:
      "linear-gradient(135deg, #edf7ff 0%, #d8ecfb 35%, #f7fbff 100%)",
    display: "flex",
    alignItems: "center",
    position: "relative",
    overflow: "hidden",
  }}
>
  {/* background circles always behind */}
  <div
    style={{
      position: "absolute",
      top: "8%",
      left: "-80px",
      width: "260px",
      height: "260px",
      borderRadius: "50%",
      background: "rgba(29,169,232,0.10)",
      filter: "blur(10px)",
      animation: "floatY 5s ease-in-out infinite",
      zIndex: 0,
      pointerEvents: "none",
    }}
  ></div>

  <div
    style={{
      position: "absolute",
      bottom: "10%",
      right: "-80px",
      width: "320px",
      height: "320px",
      borderRadius: "50%",
      background: "rgba(11,92,173,0.10)",
      filter: "blur(10px)",
      animation: "floatY 6s ease-in-out infinite",
      zIndex: 0,
      pointerEvents: "none",
    }}
  ></div>

  <div
    className="container py-5"
    style={{
      position: "relative",
      zIndex: 2,
    }}
  >
    <div className="row align-items-center gy-5">
      {/* LEFT SIDE */}
      <div className="col-lg-6 d-flex">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
              backgroundColor: "#e6f4ff",
              color: "#0B5CAD",
              padding: "10px 18px",
              borderRadius: "30px",
              fontWeight: 700,
              fontSize: "14px",
              marginBottom: "20px",
              animation: "fadeUp 1s ease",
              width: "fit-content",
              flexWrap: "wrap",
            }}
          >
            <span style={{ color: "#0B5CAD" }}>AUTOMATION</span>
            <span style={{ color: "#0B5CAD" }}>|</span>
            <span style={{ color: "#5b5cf0" }}>ENERGY</span>
            <span style={{ color: "#0B5CAD" }}>|</span>
            <span style={{ color: "#0B5CAD" }}>SUSTAINABILITY</span>
          </div>

          <h1
            style={{
              fontSize: "clamp(2.2rem, 5vw, 4rem)",
              fontWeight: 800,
              color: "#0B5CAD",
              lineHeight: "1.15",
              marginBottom: "18px",
              animation: "fadeUp 1s ease",
            }}
          >
            Simplifying Automation.
            <br />
            Empowering Sustainability
          </h1>

          <p
            style={{
              fontSize: "17px",
              color: "#4a5568",
              lineHeight: "1.8",
              maxWidth: "620px",
              marginBottom: "28px",
              animation: "fadeUp 1.2s ease",
            }}
          >
            Electromates Robotics & Automation (India) Pvt. Ltd. delivers
            industrial automation, energy-efficient technologies and
            sustainable infrastructure solutions backed by decades of
            engineering expertise.
          </p>

          <div
            className="d-flex flex-wrap gap-3"
            style={{ animation: "fadeUp 1.4s ease" }}
          >
            <a
              href="/about"
              className="btn"
              style={{
                backgroundColor: "#0B5CAD",
                color: "#fff",
                padding: "12px 26px",
                borderRadius: "30px",
                fontWeight: 600,
                border: "none",
              }}
            >
              Explore Company
            </a>

            <a
              href="/contact"
              className="btn"
              style={{
                backgroundColor: "transparent",
                color: "#0B5CAD",
                padding: "12px 26px",
                borderRadius: "30px",
                fontWeight: 600,
                border: "2px solid #0B5CAD",
              }}
            >
              Contact Us
            </a>
          </div>
        </div>
      </div>

      {/* RIGHT SIDE */}
      <div className="col-lg-6 d-flex">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            gap: "18px",
          }}
        >
          <div
            style={{
              background: "linear-gradient(135deg, #ffffff 0%, #eef7ff 100%)",
              borderRadius: "28px",
              width: "100%",
              boxShadow: "0 18px 45px rgba(11,92,173,0.12)",
              border: "1px solid rgba(11,92,173,0.08)",
              position: "relative",
              overflow: "hidden",
              animation: "zoomInSoft 1.2s ease",
              aspectRatio: "16 / 11",
            }}
          >
            <img
              src={Home1}
              alt="Electromates Hero"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                display: "block",
              }}
            />
          </div>

         <div className="row g-3">
  {[
    { number: "30+", label: "Years of Service" },
    { number: "6+", label: "Solution Domains" },
    { number: "Trusted", label: "Engineering Delivery" },
  ].map((item, index) => (
    <div className="col-4" key={index}>
      <div
        style={{
          backgroundColor: "#ffffff",
          padding: "20px",
          borderRadius: "18px",
          boxShadow: "0 10px 30px rgba(11,92,173,0.08)",
          textAlign: "center",
          height: "100%",
          animation: `fadeUp ${1.3 + index * 0.2}s ease`,
        }}
      >
        <h3
          style={{
            color: "#1DA9E8",
            fontWeight: 800,
            marginBottom: "8px",
            fontSize: "clamp(1rem, 2vw, 1.6rem)",
          }}
        >
          {item.number}
        </h3>
        <p
          style={{
            margin: 0,
            color: "#2d3748",
            fontWeight: 600,
            fontSize: "clamp(11px, 1.5vw, 14px)",
            lineHeight: "1.4",
          }}
        >
          {item.label}
        </p>
      </div>
    </div>
  ))}
</div>
        </div>
      </div>
    </div>
  </div>

  <style>
    {`
      @media (max-width: 991px) {
        .container.py-5 {
          padding-top: 70px !important;
          padding-bottom: 70px !important;
        }
      }

      @media (max-width: 767px) {
        section[style*="min-height: 92vh"] {
          min-height: auto !important;
        }
      }
    `}
  </style>
</section>

      <section className="py-5">
        <div className="container py-4">
          <div className="row align-items-center gy-4">
            <div className="col-lg-6">
              <div
                style={{
                  backgroundColor: "#ffffff",
                  borderLeft: "6px solid #1DA9E8",
                  borderRadius: "18px",
                  padding: "32px",
                  boxShadow: "0 12px 35px rgba(0,0,0,0.05)",
                }}
              >
                <h2
                  style={{
                    color: "#0B5CAD",
                    fontWeight: 800,
                    marginBottom: "18px",
                  }}
                >
                  About Electromates
                </h2>
                <p style={{ color: "#4a5568", lineHeight: "1.9" }}>
                  Established in 1992, Electromates is a professionally managed
                  engineering solutions company focused on industrial
                  automation, energy-efficient technologies and sustainable
                  infrastructure solutions.
                </p>
                <p
                  style={{
                    color: "#4a5568",
                    lineHeight: "1.9",
                    marginBottom: 0,
                  }}
                >
                  With strong engineering fundamentals, solution-centric design
                  and disciplined execution, the company helps industries
                  improve operational excellence, reliability, productivity and
                  environmental performance.
                </p>
              </div>
            </div>

<div className="col-lg-6">
  <div
    style={{
      width: "100%",
      background: "linear-gradient(135deg, #eaf6ff 0%, #ffffff 100%)",
      borderRadius: "24px",
      border: "2px dashed #9ad3f5",
      overflow: "hidden",
      position: "relative",
      aspectRatio: "16 / 10",
    }}
  >
    <img
      src={About1}
      alt="About Electromates"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "cover",
        display: "block",
      }}
    />
  </div>
</div>
          </div>
        </div>
      </section>

   <section
  className="py-5"
  style={{
    background: "linear-gradient(180deg, #ffffff 0%, #eef7fd 100%)",
  }}
>
  <div className="container py-4">
    <div className="text-center mb-5">
      <h2
        style={{
          color: "#0B5CAD",
          fontWeight: 800,
          marginBottom: "12px",
        }}
      >
        Core Capabilities
      </h2>
      <p
        style={{
          maxWidth: "780px",
          margin: "0 auto",
          color: "#5b6777",
          lineHeight: "1.8",
        }}
      >
        Electromates delivers automation systems, energy-efficiency
        solutions, engineering integration and technology-backed products
        for industrial and infrastructure applications.
      </p>
    </div>

    <div className="row g-4">
      {capabilities.map((item, index) => (
        <div className="col-lg-3 col-md-6" key={index}>
          <div
            style={{
              backgroundColor: "#ffffff",
              borderRadius: "22px",
              padding: "28px",
              height: "100%",
              boxShadow: "0 14px 34px rgba(11,92,173,0.08)",
              transition: "0.3s",
            }}
          >
           <div
  style={{
    width: "62px",
    height: "62px",
    borderRadius: "16px",
    backgroundColor: "#e6f4ff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "18px",
    overflow: "hidden",
    padding: 0,
  }}
>
  <img
    src={item.image}
    alt={item.title}
    style={{
      width: "100%",
      height: "100%",
      objectFit: "cover", // use "contain" if you don't want cropping
      display: "block",
    }}
  />
</div>

            <h4
              style={{
                color: "#0B5CAD",
                fontWeight: 700,
                marginBottom: "16px",
                fontSize: "22px",
              }}
            >
              {item.title}
            </h4>

            <ul style={{ paddingLeft: "18px", marginBottom: 0 }}>
              {item.points.map((point, i) => (
                <li
                  key={i}
                  style={{
                    color: "#4a5568",
                    lineHeight: "1.9",
                    marginBottom: "6px",
                  }}
                >
                  {point}
                </li>
              ))}
            </ul>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>

<section className="py-5">
  <div className="container py-4">
    <div
      style={{
        background: "linear-gradient(135deg, #f8fcff 0%, #eef7ff 100%)",
        borderRadius: "30px",
        padding: "48px 36px",
        boxShadow: "0 18px 45px rgba(11,92,173,0.08)",
        border: "1px solid rgba(29,169,232,0.10)",
      }}
    >
      <div className="row align-items-center gy-4">
        <div className="col-lg-5">
          <div>
            <h2
              style={{
                color: "#0B5CAD",
                fontWeight: 800,
                marginBottom: "16px",
                fontSize: "clamp(2rem, 3vw, 2.8rem)",
                lineHeight: "1.2",
              }}
            >
              Solutions We Offer
            </h2>

            <p
              style={{
                color: "#5b6777",
                lineHeight: "1.9",
                marginBottom: "24px",
                fontSize: "15px",
                maxWidth: "500px",
              }}
            >
              Solutions across digital factory automation, energy monitoring,
              ventilation, efficient motors, lighting and emission control
              applications.
            </p>

            <a
              href="/solutions"
              className="btn"
              style={{
                background: "linear-gradient(135deg, #0B5CAD 0%, #1DA9E8 100%)",
                color: "#fff",
                padding: "12px 26px",
                borderRadius: "30px",
                fontWeight: 600,
                border: "none",
                boxShadow: "0 10px 24px rgba(11,92,173,0.22)",
              }}
            >
              View All Solutions
            </a>
          </div>
        </div>
<div className="col-lg-7">
  <div
    style={{
      position: "relative",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
    }}
  >
    <div
      style={{
        position: "absolute",
        width: "360px",
        height: "360px",
        borderRadius: "50%",
        filter: "blur(50px)",
        zIndex: 0,
        pointerEvents: "none",
      }}
    ></div>

    <div
      style={{
        width: "100%",
        position: "relative",
        zIndex: 1,
        borderRadius: "28px",
        overflow: "hidden",
        aspectRatio: "16 / 10",
      }}
    >
      <img
        src={Solutions1}
        alt="Solutions"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          display: "block",
        }}
      />
    </div>
  </div>
</div>
      </div>
    </div>
  </div>
</section>

<section className="py-5">
  <div className="container py-4">
    <div
      style={{
        background: "linear-gradient(135deg, #f8fcff 0%, #eef7ff 100%)",
        borderRadius: "30px",
        padding: "48px 36px",
        boxShadow: "0 18px 45px rgba(11,92,173,0.08)",
        border: "1px solid rgba(29,169,232,0.10)",
      }}
    >
      <div className="row align-items-center gy-4">
        <div className="col-lg-5 order-1 order-lg-2">
          <div>
            <h2
              style={{
                color: "#0B5CAD",
                fontWeight: 800,
                marginBottom: "16px",
                fontSize: "clamp(2rem, 3vw, 2.8rem)",
                lineHeight: "1.2",
              }}
            >
              Services We Provide
            </h2>

            <p
              style={{
                color: "#5b6777",
                lineHeight: "1.9",
                marginBottom: "24px",
                fontSize: "15px",
                maxWidth: "500px",
              }}
            >
              Services covering engineering design, installation,
              commissioning, retrofit, modernization, maintenance support,
              consulting and long-term operational assistance.
            </p>

            <a
              href="/services"
              className="btn"
              style={{
                background: "linear-gradient(135deg, #0B5CAD 0%, #1DA9E8 100%)",
                color: "#fff",
                padding: "12px 26px",
                borderRadius: "30px",
                fontWeight: 600,
                border: "none",
                boxShadow: "0 10px 24px rgba(11,92,173,0.22)",
              }}
            >
              View All Services
            </a>
          </div>
        </div>

        <div className="col-lg-7 order-2 order-lg-1">
          <div
            style={{
              position: "relative",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <div
              style={{
                position: "absolute",
                width: "360px",
                height: "360px",
                borderRadius: "50%",
                filter: "blur(50px)",
                zIndex: 0,
                pointerEvents: "none",
              }}
            ></div>

            <div
              style={{
                width: "100%",
                position: "relative",
                zIndex: 1,
                borderRadius: "28px",
                overflow: "hidden",
                aspectRatio: "16 / 10",
              }}
            >
              <img
                src={Services1}
                alt="Services"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  display: "block",
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

    <section
  className="py-5"
  style={{
    background: "linear-gradient(180deg, #ffffff 0%, #eef7fd 100%)",
    overflow: "hidden",
  }}
>
  <div className="container py-4">
    <div className="text-center mb-5">
      <h2
        style={{
          color: "#0B5CAD",
          fontWeight: 800,
          marginBottom: "12px",
        }}
      >
        Trusted By Industry
      </h2>

      <p
        style={{
          color: "#5b6777",
          maxWidth: "760px",
          margin: "0 auto",
          lineHeight: "1.8",
        }}
      >
        A wide client spread across automotive, manufacturing, healthcare,
        electrical and industrial sectors.
      </p>
    </div>

    <div
      style={{
        position: "relative",
        overflow: "hidden",
        width: "100%",
      }}
      onMouseEnter={(e) => {
        const track = e.currentTarget.querySelector(".clients-track");
        if (track) track.style.animationPlayState = "paused";
      }}
      onMouseLeave={(e) => {
        const track = e.currentTarget.querySelector(".clients-track");
        if (track) track.style.animationPlayState = "running";
      }}
    >
      {/* Left Fade */}
      <div
        style={{
          position: "absolute",
          left: 0,
          top: 0,
          bottom: 0,
          width: "90px",
          zIndex: 2,
          pointerEvents: "none",
          background:
            "linear-gradient(90deg, #eef7fd 0%, rgba(238,247,253,0.85) 35%, rgba(238,247,253,0) 100%)",
        }}
      />

      {/* Right Fade */}
      <div
        style={{
          position: "absolute",
          right: 0,
          top: 0,
          bottom: 0,
          width: "90px",
          zIndex: 2,
          pointerEvents: "none",
          background:
            "linear-gradient(270deg, #eef7fd 0%, rgba(238,247,253,0.85) 35%, rgba(238,247,253,0) 100%)",
        }}
      />

      <div
        className="clients-track"
        style={{
          display: "flex",
          width: "max-content",
          gap: "20px",
          animation: "scrollClients 30s linear infinite",
        }}
      >
        {[...clients, ...clients].map((client, index) => (
          <div
            key={index}
            style={{
              minWidth: "180px",
              maxWidth: "180px",
              backgroundColor: "#ffffff",
              borderRadius: "20px",
              padding: "20px 16px",
              textAlign: "center",
              boxShadow: "0 10px 30px rgba(11,92,173,0.08)",
              border: "1px solid rgba(11,92,173,0.08)",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-4px)";
              e.currentTarget.style.boxShadow =
                "0 16px 34px rgba(11,92,173,0.14)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow =
                "0 10px 30px rgba(11,92,173,0.08)";
            }}
          >
            <div
              style={{
                width: "100px",
                height: "64px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "12px",
              }}
            >
              <img
                src={client.logo}
                alt={client.name}
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "contain",
                  display: "block",
                }}
              />
            </div>

            <div
              style={{
                color: "#0B5CAD",
                fontWeight: 700,
                fontSize: "15px",
                lineHeight: "1.4",
                minHeight: "40px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {client.name}
            </div>
          </div>
        ))}
      </div>
    </div>

    <style>
      {`
        @keyframes scrollClients {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
      `}
    </style>
  </div>
</section>

      <section className="py-5">
        <div className="container py-4">
          <div
            style={{
              background: "linear-gradient(135deg, #0B5CAD 0%, #1DA9E8 100%)",
              borderRadius: "28px",
              padding: "50px 30px",
              textAlign: "center",
              color: "#ffffff",
              boxShadow: "0 16px 40px rgba(11,92,173,0.20)",
            }}
          >
            <h2
              style={{
                fontWeight: 800,
                marginBottom: "14px",
              }}
            >
              Ready to Build Smarter, Efficient Operations?
            </h2>
            <p
              style={{
                maxWidth: "760px",
                margin: "0 auto 24px",
                lineHeight: "1.85",
                color: "rgba(255,255,255,0.92)",
              }}
            >
              From automation and monitoring to sustainability and retrofit
              solutions, Electromates helps industries move toward efficient,
              reliable and future-ready systems.
            </p>

            <a
              href="/contact"
              className="btn"
              style={{
                backgroundColor: "#ffffff",
                color: "#0B5CAD",
                padding: "12px 28px",
                borderRadius: "30px",
                fontWeight: 700,
                border: "none",
              }}
            >
              Get In Touch
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;